<template>
  <div class="usually-info">
    <div class="product-header">
      <!-- 价格信息区域 -->
      <div class="product-left">
        <span class="price"><em>¥</em>{{ dataInfo.installmentInfo.amountPerMonth }}</span>
        <span class="term">x{{ dataInfo.installmentInfo.term }}期</span>
        <img
          src="https://pic6.zhuanstatic.com/zhuanzh/f5910255-6135-44b5-a7da-21d5c25f6b2b.png"
          @click="showInfo"
        />
        <span class="sell-price" v-if="handPriceVo && handPriceVo.priceCent"
          >售价<em>¥</em><span>{{ handPriceVo.priceCent / 100 }}</span></span
        >
        <span class="debut-price" v-if="handPriceVo && handPriceVo.debutPrice"
          >发售价<em>¥</em><span>{{ handPriceVo.debutPrice / 100 }}</span></span
        >
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog } from '@zz-common/zz-ui'
import { defineComponent, computed } from '@vue/composition-api'

Vue.use(Dialog)
export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    feedbackData: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const discountTag = computed(() => {
      const tag = props.dataInfo.handPriceVo.discountTag || ''
      if (tag) {
        return tag.slice(0, tag.length - 1) || ''
      }
      return false
    })

    const handPriceVo = computed(() => {
      return props.dataInfo.handPriceVo
    })

    const showInfo = () => {
      Dialog({
        message: '本页面分期金额为估算金额，具体金额以提交订单后的选择确定',
        confirmButtonText: '知道了',
        closeOnClickOverlay: true
      })
    }
    return {
      discountTag,
      handPriceVo,
      showInfo
    }
  }
})
</script>

<style lang="scss" scoped>
.usually-info {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 12px;
  padding: 36px 24px 28px;
  background: #f8f8f8;
  border-radius: 32px 16px 16px;
  .product-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    //   margin-bottom: 16px;
    .product-left {
      display: flex;
      align-items: flex-end;

      .price {
        font-weight: 500;
        font-size: 64px;
        font-family: Akrobat-ExtraBold;
        line-height: 48px;

        em {
          margin-right: 4px;
          color: #000000;
          color: #111111;
          font-weight: 800;
          font-size: 36px;
          font-family: Avenir-Heavy, Avenir;
          line-height: 0.8;
        }
      }
      .term {
        position: relative;
        height: 20px;
        margin-left: 8px;
        color: #111111;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 20px;
      }
      img {
        position: relative;
        bottom: 0;
        width: 18px;
        height: 18px;
        margin-bottom: 3px;
        margin-left: 4px;
      }
      .sell-price,
      .debut-price {
        height: 20px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 300;
        color: #999999;
        line-height: 20px;
      }
      .sell-price {
        margin-left: 14px;
      }
      .debut-price {
        margin-left: 8px;
        > span {
          text-decoration: line-through;
        }
      }
    }
  }
}
</style>
